import React from 'react';
import Presenter from './ChannelPresenter'
import { withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { SEEUSER } from '../../Queries/seeUser';

export default withRouter(({ match: { params: { channelId } } }) => {
    /**
     * 인증 필요 나의 채널이 맞다면 
     */
    const {data, loading} = useQuery(SEEUSER,{
        variables:{
            channelId
        }
    })
    
    return <Presenter data={data} loading={loading} channelId={channelId}/>;
})